import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.slotsPerTimeRange', [
  'whyline.resources.resource',
]);

const SlotsPerTimeRangeFactory = ($timeout, $http, API_URL, Resource) => {
  /*@ngInject*/
  // API REST Resource Name
  const _type = 'slots-per-time-range?placeId';
  const apiEndPoint = `${API_URL}${_type}`;

  const _schema = {
    dateFrom: {
      type: String,
      required: true
    },
    dateTo: {
        type: String,
        required: true
      },
      areaId: {
        type: String,
        required: true
    },
    capacity: {
        type: Number,
        required: true
    },
    enabled: {
        type: Boolean,
        required: true,
    }
  };

  const SlotsPerTimeRange = function (data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });
  };

  SlotsPerTimeRange.GetByFilter = filter => {
    let url = `${API_URL}${_type}/getByFilter`;
    return $http.post(url, filter).then(({ data }) => data);
  };

  SlotsPerTimeRange.DeleteConfig = id => {
    const url = `${API_URL}${_type}/${id}`;
    return $http.delete(url);
  };

  SlotsPerTimeRange.prototype = new Resource(_type, _schema, SlotsPerTimeRange);

  Resource.Extend(_type, SlotsPerTimeRange);

  //one hour
  const validityTime = 60 * 60 * 5000;
  SlotsPerTimeRange.InitCache(validityTime);

  return SlotsPerTimeRange;
};

module.exports = module.factory('SlotsPerTimeRange', SlotsPerTimeRangeFactory);
